/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".collapsible-schedule[_ngcontent-%COMP%]{overflow:hidden}.collapsible-schedule-table[_ngcontent-%COMP%]{width:100%}.collapsible-schedule-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:10%}.collapsible-schedule-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-child{position:relative}.collapsible-schedule-item[_ngcontent-%COMP%]{position:absolute;width:99%}"];
export { styles as styles };
